import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { useApi } from "@/lib/api";
import { Page } from "@/components/common";
import { GetTheAppBanner } from "@/components/GetTheApp";

const isPaid = (d) => d?.payment_status === "paid" || d?.status === "paid" || d?.status === "complete";
const isFailed = (d) => d?.status === "expired" || d?.payment_status === "failed";

export default function PaymentStatus() {
  const [sp] = useSearchParams();
  const sid = sp.get("session_id");
  const { data } = useApi(sid ? `/payments/status/${sid}` : null, { refetchInterval: 2500 });
  const paid = isPaid(data);
  const failed = isFailed(data);
  return (
    <Page className="max-w-xl text-center">
      <div data-testid="payment-status" className="rise rounded-3xl bg-white border border-stone-200 p-10">
        {paid ? <CheckCircle2 className="h-14 w-14 mx-auto text-emerald-600" /> : failed ? <XCircle className="h-14 w-14 mx-auto text-red-600" /> : <Loader2 className="h-14 w-14 mx-auto animate-spin text-[#FF5C00]" />}
        <h1 data-testid="payment-status-title" className="mt-6 font-display text-3xl font-black">
          {paid ? "You're in!" : failed ? "Payment didn't go through" : "Confirming your payment..."}
        </h1>
        <p className="mt-2 text-stone-500 text-sm">{paid ? "Your ticket is in My Tickets on the website and in the app." : failed ? "No charge was made. You can try again." : "This only takes a few seconds."}</p>
        <div className="mt-8 flex flex-wrap justify-center gap-3 [&>a]:whitespace-nowrap">
          <Link to="/tickets" data-testid="payment-go-tickets" className="px-6 py-3 rounded-full bg-[#FF5C00] hover:bg-[#E04E00] text-white font-semibold text-sm transition-colors">My tickets</Link>
          <Link to="/events" className="px-6 py-3 rounded-full border border-stone-300 font-semibold text-sm">Browse events</Link>
        </div>
      </div>
      {paid && <div className="mt-6"><GetTheAppBanner /></div>}
    </Page>
  );
}
